import { all, call, put, takeLatest, select } from "redux-saga/effects";
import { handleRequestErrors } from "../../utils/errorHandler";
import { toast } from "react-toastify";
import {
  handleUserVerifyWithOTV,
  handleUserLoginWithOTP,
} from "./user.helpers";
import { connectNotification } from "apis/notifications";
import {
  postUserDataForOTVSuccess,
  postUserDataForOTVFailure,
} from "./user.actions";
import { setIsLoggedInUser, setLoginLoading } from "../chats/chats.actions";
import routes from "routes";
import { getNotifMsg } from "utils/message";
import { userTypes } from "./user.types";
import { FCM_TOKEN_KEY } from "constants/localStorageKeys";

const getConversationsInfo = (state) => {
  return {
    locale: state.settingsData.locale,
  };
};

export function* onPostUserDataOTP() {
  yield takeLatest(userTypes.POST_USER_DATA_OF_OTP, postUserDataForOTVSaga);
}

export function* loginUserWithOTV({ payload }) {
  const { locale } = yield select(getConversationsInfo);
  const { userCredentials, navigate } = payload;
  yield put(setLoginLoading(true));

  try {
    const returnedData = yield handleUserLoginWithOTP(userCredentials);

    if (returnedData.user.id && returnedData.token) {
      localStorage.setItem("raychat_web_app_token", returnedData.token);
      localStorage.setItem("raychat_web_app_agentId", returnedData.user.id);

      const fcmTokenSavedInStorage = localStorage.getItem(FCM_TOKEN_KEY);

      // if fcm token has already saved in local storage
      if (fcmTokenSavedInStorage) {
        yield call(
          connectNotification,
          fcmTokenSavedInStorage,
          returnedData.token
        );
      }

      yield put(setIsLoggedInUser(true));

      navigate(routes.home);

      yield put(setLoginLoading(false));
    }
  } catch (error) {
    yield put(setLoginLoading(false));
    if (error.message === "Network Error") {
      toast.error(getNotifMsg("CHECK_YOUR_CONNECTION", locale));
      return;
    }

    if (
      error.response?.status === 400 &&
      error.response?.data?.message === "code incorrect"
    ) {
      toast.error(getNotifMsg("WRONG_ENTERED_CODE", locale));
      return;
    }

    handleRequestErrors(error.response, locale);
  }
}

export function* onLoginUserStart() {
  yield takeLatest(
    userTypes.LOGIN_USER_ONE_TIME_VERIFICATION,
    loginUserWithOTV
  );
}

export default function* userSagas() {
  yield all([call(onPostUserDataOTP), call(onLoginUserStart)]);
}

export function* postUserDataForOTVSaga(action) {
  const { locale } = yield select(getConversationsInfo);

  try {
    const response = yield call(handleUserVerifyWithOTV, action.payload);
    if (response.success) {
      yield put(postUserDataForOTVSuccess(response));
      if (action.payload.type === "email") {
        toast.success(
          getNotifMsg("VERIFY_CODE_SUCCESSFULLY_SEND_TO_YOUR_EMAIL", locale)
        );
        return;
      }
      toast.success(
        getNotifMsg("VERIFY_CODE_SUCCESSFULLY_SEND_TO_YOUR_PHONE", locale)
      );
      return;
    }
  } catch (error) {
    yield put(postUserDataForOTVFailure(error));
    if (error.message === "Network Error") {
      toast.error(getNotifMsg("CHECK_YOUR_CONNECTION", locale));
      return;
    }
    handleRequestErrors(error.response, locale);
  }
}
